import { useCallback } from 'react';

import { useSetupIntent } from '../useSetupIntent';
import { useCustomerSessionQuery } from './graphql/CustomerSession.generated';

export const useCustomerSession = () => {
  const [response, refetchCustomerSession] = useCustomerSessionQuery({
    requestPolicy: 'network-only',
  });

  const customerId = response.data?.customerPaymentInfo?.id;
  const customerSessionClientSecret = response.data?.customerPaymentInfo?.paymentSessionId; // prettier-ignore
  const hasCustomerSessionError = Boolean(response.error);

  const {
    setupIntentSecret,
    refetchSetupIntent,
    hasError: hasSetupIntentError,
  } = useSetupIntent(!customerId);

  const refetch = useCallback(() => {
    refetchCustomerSession({ requestPolicy: 'network-only' });
    if (customerId) void refetchSetupIntent({});
  }, [customerId, refetchCustomerSession, refetchSetupIntent]);

  const isFetching = !customerSessionClientSecret || !setupIntentSecret;
  const hasError = hasCustomerSessionError || hasSetupIntentError;

  return {
    customerId,
    customerSessionClientSecret,
    setupIntentSecret,
    isFetching,
    hasError,
    refetch,
  };
};
